<section class="cbanner bannerbgcolor overflow-hidden position-relative">
	<div class="container">
		<div class="row">
			<div
				class="col-xxl-12 col-xl-11 col-lg-11 col-md-11 col-ms-11 col-11 mx-auto"
				data-aos="fade-up"
				data-aos-duration="2000"
				data-aos-delay="100"
			>
				<!-- <img class="img-globe floatimg" src="{{baseUrl}}/img/3D-images/branding-01.png" alt="Branding agency Dubai" height="" width="" loading="lazy"> -->

				<div id="spline-container">
					<!-- <canvas
						id="canvas"
						class="floatimg"
						style="cursor: pointer !important"
					></canvas> -->

					<spline-viewer
						class="floatimg"
						url="https://prod.spline.design/lOwCHnDGwjVf9GgA/scene.splinecode"
					></spline-viewer>
					<!-- <div #canvas style="width: 100%; height: 100%" class="floatimg"></div> -->
				</div>
				<div class="banner vh-100">
					<div
						class="d-flex flex-column justify-content-center h-100 align-items-start"
					>
						<div
							class="contentbl"
							data-aos="fade-up"
							data-aos-duration="1000"
							data-aos-delay="100"
						>
							<h1 class="h1 size90 d-flex flex-column">
								<span
									>Build a
									<span class="barcely"> Brand </span>
								</span>
								<span> that feels just right. </span>
							</h1>
						</div>
					</div>
				</div>
				<div class="position-absolute banner-left-content content-left">
					<ul
						class="d-flex flex-column justify-contente-arround p-0 float-start"
						style="
							height: 130px;
							list-style: none;
							justify-content: space-between;
						"
					>
						<li>
							<a
								class=""
								href="https://www.instagram.com/pixtar.ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/instagram.svg"
									alt="Corporate rebranding solutions"
									width="15"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class=""
								href="https://www.facebook.com/pixtar.ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/facebook.svg"
									alt="Brand design services in dubai"
									width="10"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class=""
								href="https://www.linkedin.com/company/pixtar-ae/"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/social-media/linkedin.svg"
									alt="Best branding agency dubai"
									width="15"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
						<li>
							<a
								class="whatsapp-icon2 slideUpReturn tabmob"
								href="https://wa.me/+971527930781"
								target="_blank"
							>
								<img
									src="{{ baseUrl }}/img/home/whatsapp.svg"
									alt="top branding agency in dubai"
									width="18"
									height=""
									loading="lazy"
								/>
							</a>
						</li>
					</ul>
					<div class="d-flex flex-column justify-contente-center left-content2">
						<p class="size24 textcolor1 lufgaregular">
							Crafted with the precision of
						</p>
						<p class="size24 textcolor1 lufgaregular">
							the golden ratio and originality
						</p>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="position-absolute start-50 translate-middle down-arrow">
			<p>
				<a href="/services/branding#packages" class="cstbtn package">
					<span class="text semibold"> Explore Packages</span>
					<span class="borderspan"> <i class="fa fa-chevron-right" aria-hidden="true"></i> 
					</span>
				</a>
			</p>
		</div> -->
		<div class="position-absolute translate-middle down-arrow">
			<div class="linkToPackages">
				<a
					type="button"
					href="/services/branding#packages"
					class="d-flex justify-content-start align-items-center"
				>
					<span class="text textcolor1 semibold text-capitalize">
						Explore Packages
					</span>
					<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->

					<lucide-icon
						name="chevron-right"
						class="lucide-arrow-icon"
					></lucide-icon>

					<span class="borderspan"> </span>
				</a>
			</div>
		</div>
	</div>
</section>
<!-- Banner ends-->
<div class="bannerbgcolor cstheight"></div>
<section class="cstvideo">
	<div class="container-fluid">
		<div class="row">
			<div
				class="col-md-12 col-sm-11 col-11 mx-auto"
				[ngStyle]="{ width: sectionWidth + '%' }"
			>
				<div class="video-frame">
					<video
						#myVideo
						width="100%"
						muted
						autoplay
						(click)="playInFullscreenWithAudio()"
						style="cursor: pointer"
					>
						<source
							src="{{ baseUrl }}/what is brandng pixtar 2.mp4"
							type="video/mp4"
						/>
						<source
							src="{{ baseUrl }}/what is brandng pixtar 2.mp4"
							type="video/ogg"
						/>
						Your browser does not support the video tag.
					</video>
				</div>
			</div>
		</div>
	</div>
</section>
<section class="aboutbrand mrem55">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="about-brand">
					<h2 class="size55 weight300 light">
						<span class="textcolor1"> Your brand isn’t just a</span>
						<span class="barcely"> Logo</span>.
						<span class="textcolor2">It’s how the world sees you. At </span>
						<span class="textcolor1"> Pixtar</span>,
						<span class="textcolor2">
							we blend art with strategy to create bespoke branding solutions
						</span>
						that <span class="textcolor1">make your story unforgettable.</span>
					</h2>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- Recent works -->
<!-- <section class="topdist bannerdrk hard-work">
	<div
		class="container d-none d-sm-none d-md-block d-lg-block d-xl-block d-xxl-block"
	>
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="d-flex justify-content-start align-items-center cmargin">
					<h2 class="text-white h1">
						<div class="line"></div>
						Recent Works
					</h2>
				</div>
			</div>
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="row">
					<div
						class="col-md-6"
						*ngFor="let project of allprojects; let i = index"
					>
						<div class="imgblock">
							<a href="{{ project.link }}" target="_blank">
								<img
									src="{{ imagepath }}project/{{ project.image }}"
									height=""
									width=""
									alt="Custom Branding Services"
									class="galleryimg{{ i }}"
									(mouseenter)="onMouseEnter(i)"
									(mouseleave)="onMouseLeave()"
									loading="lazy"
								/>
								<div class="box-name text-center">
									<p class="mb-0 textcolor5 h2">{{ project.name }}</p>
									<p class="textcolor4">
										<span [innerHTML]="project.desc"></span>
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	recent work slider code
	<div
		class="customslider d-block d-sm-block d-md-none d-lg-none d-xl-none d-xxl-none"
		data-aos="fade-up"
		data-aos-duration="1000"
		data-aos-delay="100"
	>
		<div class="col-md-10 offset-md-1">
			<div class="d-flex justify-content-start align-items-center cmargin">
				<h2 class="text-white h1">
					<div class="line"></div>
					Recent Works
				</h2>
			</div>
		</div>
		<owl-carousel-o [options]="recentoptions">
			<ng-container *ngFor="let project of allprojects; let i = index">
				<ng-template carouselSlide [id]="project + i">
					<a href="{{ project.link }}" target="_self">
						<img
							src="{{ imagepath }}project/{{ project.project_images[0] }}"
							width=""
							height=""
							loading="lazy"
						/>
						<div class="box-name text-center">
							<p class="mb-0 textcolor5 h2">{{ project.name }}</p>
							<p class="textcolor4"><span [innerHTML]="project.desc"></span></p>
						</div>
					</a>
				</ng-template>
			</ng-container>
		</owl-carousel-o>
	</div>
	recent work slider code
	<div class="section bannerdrk mt-md-5 mt-sm-4 mt-4">
		<div class="row">
			<div class="col-md-10 m-auto">
				<div
					class="d-flex flex-column justify-content-center align-items-center video-block"
				>
					<div class="position-relative">
						<div class="float-start cwd243">
							<p>
								<a
									href="/contact/branding"
									rel="noopener"
									class="cstbtn cstbtn128 textcolor5"
								>
									<span class="text text128 textcolor5"
										>Book A Consultation</span
									>
									<span class="borderspan"
										> <i class="fa fa-chevron-right" aria-hidden="true"></i>
					<lucide-icon
						name="chevron-right"
						class="lucide-arrow-icon"
					></lucide-icon>
									</span>
								</a>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section> -->

<section class="topdist bannerdrk hard-work">
	<div class="container d-none d-md-block">
		<div class="row">
			<div class="col-11 mx-auto">
				<div class="d-flex justify-content-start align-items-center cmargin">
					<h2 class="text-white size32 bold">
						<div class="line"></div>
						Recent Works
					</h2>
				</div>
			</div>
			<div class="col-11 mx-auto">
				<div class="row">
					<div
						class="col-md-6"
						*ngFor="let project of allprojects; let i = index"
					>
						<div class="imgblock">
							<a href="{{ project.link }}" target="_blank">
								<img
									src="{{ imagepath }}project/{{ project.image }}"
									alt="{{ project.name }}"
									class="galleryimg{{ i }}"
									loading="lazy"
								/>
								<div class="box-name text-center">
									<p class="mb-0 textcolor5 h2 bold">{{ project.name }}</p>
									<p class="textcolor4 light">
										<span [innerHTML]="project.desc"></span>
									</p>
								</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div
		class="customslider d-block d-md-none px-5"
		data-aos="fade-up"
		data-aos-duration="1000"
	>
		<div class="col-md-10 offset-md-1">
			<div class="d-flex justify-content-start align-items-center cmargin">
				<h2 class="text-white h1">
					<div class="line"></div>
					Recent Works
				</h2>
			</div>
		</div>
		<owl-carousel-o [options]="recentoptions">
			<ng-container *ngFor="let project of allprojects; let i = index">
				<ng-template carouselSlide [id]="project + i">
					<a href="{{ project.link }}" target="_self">
						<img
							src="{{ imagepath }}project/{{ project.project_images[0] }}"
							loading="lazy"
							alt="{{ project.link }}"
						/>
						<div class="box-name text-center">
							<p class="mb-0 textcolor5 h2">{{ project.name }}</p>
							<p class="textcolor4"><span [innerHTML]="project.desc"></span></p>
						</div>
					</a>
				</ng-template>
			</ng-container>
		</owl-carousel-o>
	</div>

	<div class="section bannerdrk container p-0">
		<div class="row">
			<div class="col-md-10 m-auto">
				<div
					class="d-flex flex-column justify-content-center align-items-center video-block"
				>
					<div class="position-relative">
						<div class="float-start cwd243">
							<!-- <p>
								<a href="/contact/branding" class="cstbtn cstbtn128 textcolor5">
									<span class="text fontsize14 text-white semibold">
										Book A Consultation
									</span>
									<span class="borderspan"> <i class="fa fa-chevron-right" aria-hidden="true"></i> 
					<lucide-icon
						name="chevron-right"
						class="lucide-arrow-icon"
					></lucide-icon></span>
								</a>
							</p> -->
							<div class="linkToPackages">
								<a
									type="button"
									href="/contact/branding"
									class="d-flex justify-content-start align-items-center"
								>
									<span class="text semibold text-white text-capitalize">
										Book A Consultation
									</span>
									<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
									<lucide-icon
										name="chevron-right"
										class="lucide-arrow-icon"
									></lucide-icon>
									<span class="borderspan"> </span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- Recent works -->
<!-- choose section starts -->

<section class="section choosesection">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="choose-section">
					<p class="h1 weight300 text-center">
						<span class="textcolor1 size55 medium">Why Choose Pixtar?</span>
					</p>
					<div class="mtrem5">
						<div class="row">
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/home/art-icons/solution.svg"
										alt="Professional Branding Agency Dubai"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">
										Crafted With The Golden Ratio
									</p>
									<p class="size18 textcolor3 p2">
										Everything we design follows the timeless principles of the
										golden ratio—creating perfect harmony between form and
										function.
									</p>
								</div>
							</div>
							<div class="col-md-4 mt-md-0 mt-sm-4 mb-md-0 mb-sm-4 mb-4 mt-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/home/art-icons/craft.svg"
										alt="building brand in dubai"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">
										Custom Solutions. No Templates. Ever.
									</p>
									<p class="size18 textcolor3 p2">
										Every brand is unique, and so is our approach. We build from
										scratch, ensuring your business is reflected in every
										detail.
									</p>
								</div>
							</div>
							<div class="col-md-4">
								<div class="box text-center">
									<img
										class="mb30"
										src="{{ baseUrl }}/img/home/art-icons/beyond.svg"
										alt="affordable branding solutions"
										width=""
										height=""
										loading="lazy"
									/>
									<p class="size20 textcolor1 weight600 p1">
										Beyond The Limits, Always Transparent
									</p>
									<p class="size18 textcolor3 p2">
										We don’t just deliver; we partner with you, going above and
										beyond with 100% transparency at every step of the way.
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- choose section ends -->
<!-- client section ends -->
<!-- <section class="section client backeeedf0">
	<div class="container">
		<div class="row">
			<div class="col-xxl-12 col-xl-11 col-md-11 col-sm-11 col-11 mx-auto">
				<div class="logos">
					<h3 class="fontsize12 mb-0 semibold text-uppercase">
						Our clients include...
					</h3>
					<owl-carousel-o [options]="clientslider">
						<ng-container>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/dnour.svg"
											alt="Dnour Dubai"
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/crystal.svg"
											alt="Crystal Cargo"
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/miniaar.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>

								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img src="{{baseUrl}}/img/home/logos/bni.svg" [alt]="">
									</a>
								</div>

							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/angle.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/pakhis.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/drminnie.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/veddentta.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/autokoorosh.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/fractal.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/aetrio.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/wrae.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
							<ng-template carouselSlide>
								<div class="team-img position-relative overflow-hidden">
									<a href="#" target="_blank" rel="noopener noreferrer">
										<img
											src="{{ baseUrl }}/img/home/logos/beyou.svg"
											[alt]=""
											width=""
											height=""
											loading="lazy"
										/>
									</a>
								</div>
							</ng-template>
						</ng-container>
					</owl-carousel-o>
				</div>
			</div>
		</div>
	</div>
</section> -->
<app-clients></app-clients>

<!-- client section ends -->
<!-- packages section Start -->
<section class="section packages pt-0 backeeedf0">
	<div class="container">
		<div class="row">
			<div class="col-md-7 col-sm-11 col-11 mx-auto">
				<div class="packages-section mbrem5">
					<h3 class="wght500 text-center mb-3 mt-0">
						<span class="textcolor1 size55"
							>What’s Included in Our Branding Packages?</span
						>
					</h3>
					<p class="size24 textcolor2 text-center">
						Whether you’re starting from scratch or need a brand overhaul, we’ve
						got you covered.
					</p>
				</div>
			</div>
			<div
				class="col-lg-11 col-md-10 col-sm-11 col-11 mx-auto"
				#packages
				id="packages"
			>
				<div class="row justify-content-center">
					<div class="col-xxl-5 col-xl-5 col-lg-8 col-md-10">
						<div class="card bgblk">
							<div class="card-body">
								<div class="brd">
									<div class="d-flex">
										<div class="icons">
											<div class="circle1 pulse"></div>
											<div class="circle2"></div>
										</div>
										<div class="text">
											<p class="fontsize14 textcolor3">Slots available</p>
										</div>
									</div>
								</div>
								<h2 class="textcolor3 size90 fw-light">Join</h2>
								<h2 class="size90 weight700 text-white mt-0 mb-4">Pixtar</h2>
								<div class="box mb-2">
									<h3 class="text-white weight500 mb-2 mt-0 size24">
										Book a 15-min intro Call
									</h3>
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<p class="size18 textcolor3">
											Learn more about how Pixtar
											<span class="d-block">
												works and how it can help you.</span
											>
										</p>
										<a
											href="/contact/branding"
											rel="noopener"
											class="cstbtn"
											aria-label="Book a 15-min intro Call"
										>
											<span class="borderspan">
												<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
												<lucide-icon
													name="chevron-right"
													class="lucide-arrow-icon"
												></lucide-icon>
											</span>
										</a>
									</div>
								</div>

								<div class="box">
									<h3 class="text-white weight500 mb-2 mt-0 size24">
										Refer a friend & earn
									</h3>
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<p class="size18 textcolor3 position-relative">
											Earn 5% monthly recurring
											<span class="d-block">
												commission for each referral.
											</span>
										</p>
										<a
											(click)="openModal()"
											(keydown.enter)="openModal()"
											(keydown.space)="openModal()"
											class="cstbtn top-0"
											role="button"
											tabindex="0"
											aria-label="Get Started - Refer a friend"
										>
											<span class="borderspan">
												<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
												<lucide-icon
													name="chevron-right"
													class="lucide-arrow-icon"
												></lucide-icon>
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- whit card design -->
					<div
						class="col-xxl-7 col-xl-7 col-lg-8 col-md-10 mt-xl-0 mt-lg-5 mt-md-5 mt-sm-5 mt-5"
					>
						<div class="card shadow" style="max-width: 600px">
							<h3 class="text-start py-3 weight500 size32 m-0">
								{{ tabTitle }}
							</h3>
							<nav>
								<div class="nav nav-tabs mb-3" id="nav-tab" role="tablist">
									<button
										class="nav-link active weight500"
										id="nav-home-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-home"
										type="button"
										role="tab"
										aria-controls="nav-home"
										aria-selected="true"
										(click)="changeTabTitle('Try with us')"
									>
										Explorer
									</button>
									<button
										class="nav-link weight500"
										id="nav-profile-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-profile"
										type="button"
										role="tab"
										aria-controls="nav-profile"
										aria-selected="false"
										(click)="changeTabTitle('Most Suitable')"
									>
										<img
											src="{{ baseUrl }}/img/services/shock.png"
											alt="Creative branding services in Dubai"
											width=""
											height=""
											loading="lazy"
										/>
										Navigator
									</button>
									<button
										class="nav-link weight500"
										id="nav-contact-tab"
										data-bs-toggle="tab"
										data-bs-target="#nav-contact"
										type="button"
										role="tab"
										aria-controls="nav-contact"
										aria-selected="false"
										(click)="changeTabTitle('Create a Brand')"
									>
										Pioneer
									</button>
								</div>
							</nav>
							<div class="tab-content" id="nav-tabContent">
								<div
									class="tab-pane fade active show"
									id="nav-home"
									role="tabpanel"
									aria-labelledby="nav-home-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
											>
												AED 7,995
											</h4>
											<h5
												class="cstprng-table-about size20 textcolor1 weight500"
											>
												Perfect for startups.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size20 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Logo design (3 Options)
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Business card
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Letterhead and Envelope
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															1 Revisions (On shortlisted)
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															2 Color options
														</li>
														<li
															class="list-group-item d-flex size18 justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															13 Days Delivery
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div class="position-absolute start-50 translate-middle down-arrow">
												<p>
													<a (click)="
															getStripPayemts('Explorer', 7995, payments)
														" class="cstbtn">
														<span class="text"> Get Started</span>
														<span class="borderspan"> <i class="fa fa-chevron-right" aria-hidden="true"></i> 
					<lucide-icon
						name="chevron-right"
						class="lucide-arrow-icon"
					></lucide-icon>
														</span>
													</a>
												</p>
											</div> -->
											<div class="linkToPackages">
												<button
													type="button"
													(click)="getStripPayemts('Explorer', 7995, payments)"
													class="d-flex justify-content-start align-items-center"
												>
													<span class="text semibold text-capitalize">
														Get Started
													</span>
													<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
													<lucide-icon
														name="chevron-right"
														class="lucide-arrow-icon"
													></lucide-icon>
													<span class="borderspan"> </span>
												</button>
											</div>

											<p class="size14 cntlink">
												Or
												<a href="/contact/branding" rel="noopener"
													>book a call</a
												>
											</p>
										</div>
									</div>
								</div>
								<div
									class="tab-pane fade"
									id="nav-profile"
									role="tabpanel"
									aria-labelledby="nav-profile-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
											>
												AED 13,995
											</h4>
											<h5
												class="cstprng-table-about size20 textcolor1 weight500"
											>
												A full brand identity suite.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size20 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Logo design (3 Options)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Business card
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Letterhead and Envelope
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Brand Guidelines
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Packing Design (1 Product)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															2 Revisions (On shortlisted)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															5 Color options
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															10 Days Delivery
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div
												class="position-absolute start-50 translate-middle down-arrow"
											>
												<p>
													<a
														(click)="
															getStripPayemts('Navigator', 13995, payments)
														"
														class="cstbtn"
													>
														<span class="text"> Get Started</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<button
													type="button"
													(click)="
														getStripPayemts('Navigator', 13995, payments)
													"
													class="d-flex justify-content-start align-items-center"
												>
													<span class="text semibold text-capitalize">
														Get Started
													</span>
													<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
													<lucide-icon
														name="chevron-right"
														class="lucide-arrow-icon"
													></lucide-icon>
													<span class="borderspan"> </span>
												</button>
											</div>

											<p class="size14 cntlink">
												Or
												<a href="/contact/branding" rel="noopener"
													>book a call</a
												>
											</p>
										</div>
									</div>
								</div>
								<div
									class="tab-pane fade"
									id="nav-contact"
									role="tabpanel"
									aria-labelledby="nav-contact-tab"
								>
									<div class="cstprng-table">
										<div class="cstprng-table-header">
											<h4
												class="cstprng-table-cost size55 textcolor1 weight500 mt-0"
											>
												AED 48,995
											</h4>
											<h5
												class="cstprng-table-about size20 textcolor1 weight500"
											>
												The ultimate package with unlimited requests.
											</h5>
										</div>
										<div class="divider"></div>
										<div class="cstprng-table-features">
											<h5 class="size20 textcolor1 weight500">
												What’s included
											</h5>
											<div class="row">
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Logo design (Unlimited)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Business card
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Letterhead and Envelope
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Detailed Brand Guidelines
														</li>
													</ul>
												</div>
												<div class="col-md-6">
													<ul class="list-group">
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Packing Design (5 Product)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Unlimited Revisions (Shortlisted)
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															Unlimited Color options
														</li>
														<li
															class="list-group-item d-flex justify-content-start size18 align-items-center border-0 p-0 mb-2"
														>
															<!-- <i class="fa fa-check me-2"></i> -->
															<lucide-icon
																name="Check"
																class="lucide-check-icon"
															></lucide-icon>

															20 Days Delivery
														</li>
													</ul>
												</div>
											</div>
										</div>
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div
												class="position-absolute start-50 translate-middle down-arrow"
											>
												<p>
													<a
														(click)="
															getStripPayemts('Pioneer', 48995, payments)
														"
														class="cstbtn"
													>
														<span class="text"> Get Started</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->
											<div class="linkToPackages">
												<button
													type="button"
													(click)="getStripPayemts('Pioneer', 48995, payments)"
													class="d-flex justify-content-start align-items-center"
												>
													<span class="text semibold text-capitalize">
														Get Started
													</span>
													<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
													<lucide-icon
														name="chevron-right"
														class="lucide-arrow-icon"
													></lucide-icon>
													<span class="borderspan"> </span>
												</button>
											</div>

											<p class="size14 cntlink">
												Or
												<a href="/contact/branding" rel="noopener"
													>book a call</a
												>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
<!-- packages section ends -->

<!-- Successful story sections-->
<app-testimonial></app-testimonial>
<!-- Successful story sections-->

<!-- Faq section Starts -->
<app-faq-component></app-faq-component>
<!-- Faq section ends -->

<!-- Media Carosual Popup -->
<!-- <ng-template #videomodal let-modal style="z-index: 0;">
	<button type="button" class="btn" aria-describedby="modal-title" (click)="modal.dismiss('Cross click')"><span
			class="fa fa-times" aria-hidden="true"></span></button>
	<video class=" h-auto desktopimg" id="myVideo3" style="width: 100%; height:100%;" autoplay="true" loop="true"
		oncanplay="this.play()" controls>
		<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/mp4">
		<source src="{{baseUrl}}/what is brandng pixtar 2.mp4" type="video/ogg">
		Your browser does not support HTML5 video.
	</video>
</ng-template> -->

<!-- Payment Popup -->
<ng-template #payments let-modal style="z-index: 0">
	<div class="modal-header">
		<h2 class="modal-title weight500 size32" id="modal-basic-title">
			<strong>{{ paymentData.name }}</strong>
		</h2>
		<p><strong>Complete Your Payment</strong></p>
		<!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">
				×
			</span>
		</button> -->
	</div>
	<div class="modal-body">
		<div id="content">
			<div class="container">
				<div class="row">
					<div class="col-md-12">
						<div class="">
							<form
								[formGroup]="paymentForm"
								method="post"
								(ngSubmit)="submitPayment()"
								novalidate
							>
								<div class="row mrl-0 mb-3" style="padding: 5px 5px">
									<div class="form-floating mb-3">
										<input
											type="text"
											name="firstname"
											autocomplete="off"
											formControlName="firstname"
											class="form-control"
											id="floatingInput"
											placeholder="firstname"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your First Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('firstname', 'required')
											"
											class="error"
										>
											<div>First Name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="lastname"
											autocomplete="off"
											formControlName="lastname"
											class="form-control"
											id="floatingInput"
											placeholder="lastname"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Last Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('lastname', 'required')
											"
											class="error"
										>
											<div>Last Name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="email"
											name="email"
											autocomplete="off"
											formControlName="email"
											class="form-control"
											id="floatingInput"
											placeholder="email"
										/>
										<label for="floatingInput" class="mt-0"
											>What’s your e-mail?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasEmailError('email', 'required')
											"
											class="error"
										>
											<div>
												{{ hasEmailError("email", "required") }}
											</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<!-- <input type="number" name="referred_phone" autocomplete="off" formControlName="referred_phone"
											class="form-control" id="floatingInput" placeholder="name" min="0"> -->
										<ngx-intl-tel-input
											class="form-control interphone"
											id="floatingInput"
											[cssClass]="''"
											[enableAutoCountrySelect]="true"
											[enablePlaceholder]="true"
											[searchCountryFlag]="true"
											[preferredCountries]="preferredCountries"
											[searchCountryField]="[
												SearchCountryField.Iso2,
												SearchCountryField.Name
											]"
											[selectFirstCountry]="false"
											[selectedCountryISO]="CountryISO.UnitedArabEmirates"
											[tooltipField]="TooltipLabel.Name"
											[phoneValidation]="true"
											[separateDialCode]="true"
											name="contact"
											formControlName="contact"
										>
										</ngx-intl-tel-input>
										<label for="floatingInput" class="mt-0"
											>Contact Number</label
										>
										<div
											*ngIf="
												isPaymentSubmitted &&
												hasPhoneNumberError('contact', 'required')
											"
											class="error"
										>
											<div>
												{{ hasPhoneNumberError("contact", "required") }}
											</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="company"
											autocomplete="off"
											formControlName="company"
											class="form-control"
											id="floatingInput"
											placeholder="company"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Company Name?</label
										>
										<div
											*ngIf="
												isPaymentSubmitted && hasError('company', 'required')
											"
											class="error"
										>
											<div>Company name is required.</div>
										</div>
									</div>
									<div class="form-floating mb-3">
										<input
											type="text"
											name="website"
											autocomplete="off"
											formControlName="website"
											class="form-control"
											id="floatingInput"
											placeholder="website"
										/>
										<label for="floatingInput" class="mt-0"
											>What's your Company Website?</label
										>
									</div>
									<!-- <div class="form-floating mb-3">
										<input type="text" name="company_address" autocomplete="off" formControlName="company_address" class="form-control"
											id="floatingInput" placeholder="Company Address">
										<label for="floatingInput" class="mt-0">What's your Company Address?</label>
									</div> -->
									<div class="form-floating mb-3">
										<textarea
											type="text"
											rows="4"
											name="customer_message"
											autocomplete="off"
											formControlName="customer_message"
											class="form-control csttextarea"
											id="floatingInput"
											placeholder="Your Message"
										></textarea>
										<label for="floatingInput" class="mt-0"
											>Your Message?</label
										>
									</div>
									<div
										class="d-flex justify-content-center align-items-center mt-4"
									>
										<!-- <div class="text-center text-sm-start me-3">
											<input type="submit" name="submit" value="Submit" class=" submit">
										</div>
										<div class="input-group1">
											<button type="cancel" class="button text-center" (click)="closePopUp()">Cancel</button>
										</div> -->
										<div
											class="cstprng-table-cta position-relative mtrem3 started"
										>
											<!-- <div class="position-absolute customcrl">
												<p>
													<a class="cstbtn" (click)="submitPayment()">
														<span class="text text128"> Submit</span>
														<span class="borderspan"
															><i
																class="fa fa-chevron-right"
																aria-hidden="true"
															></i>
														</span>
													</a>
												</p>
											</div> -->

											<div class="linkToPackages">
												<button
													type="button"
													(click)="submitPayment()"
													class="d-flex justify-content-start align-items-center"
												>
													<span class="text semibold text-capitalize">
														Submit
													</span>
													<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
													<lucide-icon
														name="chevron-right"
														class="lucide-arrow-icon"
													></lucide-icon>
													<span class="borderspan"> </span>
												</button>
											</div>

											<p class="size14 cntlink">
												Or
												<button
													(click)="closePopUp()"
													class="text-decoration-underline"
												>
													cancel
												</button>
											</p>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<!-- Trigger Button to Open Modal -->
<!-- <button type="button" class="btn btn-primary" (click)="openModal()">Open Contact Form</button> -->
<!-- Modal Structure -->
<div
	class="modal fade"
	id="contactModal"
	tabindex="-1"
	aria-labelledby="modalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h2 class="modal-title weight500 size32" id="modal-basic-title">
					<strong>REFERRAL</strong>
				</h2>
				<p><strong>REFER A FRIEND & EARN</strong></p>
				<!-- <h5 class="modal-title weight100 size32" id="modalLabel"><strong>REFER A FRIEND & EARN</strong></h5> -->
				<!-- <button type="button" class="close" aria-label="Close" (click)="closeModal()">
					<span aria-hidden="true">
						×
					</span>
				</button> -->
			</div>
			<div class="modal-body">
				<form
					[formGroup]="referralForm"
					method="post"
					(ngSubmit)="submitReferral()"
				>
					<div class="row mrl-0 mb-3" style="padding: 5px 5px">
						<h4><strong>Your Details:</strong></h4>
						<div class="form-floating mb-3">
							<input
								type="text"
								name="referrer_name"
								autocomplete="off"
								formControlName="referrer_name"
								class="form-control"
								id="floatingInput"
								placeholder="your name"
							/>
							<label for="floatingInput" class="mt-0">Full Name</label>
							<div
								*ngIf="
									submitted && hasReferralError('referrer_name', 'required')
								"
								class="error"
							>
								<div>Your Name is required.</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								name="referrer_email"
								autocomplete="off"
								formControlName="referrer_email"
								class="form-control"
								id="floatingInput"
								placeholder="email"
							/>
							<label for="floatingInput" class="mt-0">Email Address</label>
							<div
								*ngIf="submitted && hasEmailError('referrer_email', 'required')"
								class="error"
							>
								<div>
									{{ hasEmailError("referrer_email", "required") }}
								</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<!-- <input type="number" name="referrer_phone" autocomplete="off" formControlName="referrer_phone"
								class="form-control" id="floatingInput" placeholder="name" min="0"> -->
							<ngx-intl-tel-input
								class="form-control interphone"
								id="floatingInput"
								[cssClass]="''"
								[enableAutoCountrySelect]="true"
								[enablePlaceholder]="true"
								[searchCountryFlag]="true"
								[searchCountryField]="[
									SearchCountryField.Iso2,
									SearchCountryField.Name
								]"
								[preferredCountries]="preferredCountries"
								[selectFirstCountry]="false"
								[selectedCountryISO]="CountryISO.UnitedArabEmirates"
								[tooltipField]="TooltipLabel.Name"
								[phoneValidation]="true"
								[separateDialCode]="true"
								name="referrer_phone"
								formControlName="referrer_phone"
							>
							</ngx-intl-tel-input>
							<label for="floatingInput" class="mt-0">Contact Number</label>
							<div
								*ngIf="
									submitted && hasPhoneNumberError('referrer_phone', 'required')
								"
								class="error"
							>
								<div>
									{{ hasPhoneNumberError("referrer_phone", "required") }}
								</div>
							</div>
						</div>
						<h4 class="mt-2"><strong>Your Friend’s Details:</strong></h4>
						<div class="form-floating mb-3">
							<input
								type="text"
								name="referred_name"
								autocomplete="off"
								formControlName="referred_name"
								class="form-control"
								id="floatingInput"
								placeholder="name"
							/>
							<label for="floatingInput" class="mt-0">Full Name</label>
							<div
								*ngIf="
									submitted && hasReferralError('referred_name', 'required')
								"
								class="error"
							>
								<div>Your Friend’s Name is required.</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<input
								type="email"
								name="referred_email"
								autocomplete="off"
								formControlName="referred_email"
								class="form-control"
								id="floatingInput"
								placeholder="email"
							/>
							<label for="floatingInput" class="mt-0">Email Address</label>
							<div
								*ngIf="submitted && hasEmailError('referred_email', 'required')"
								class="error"
							>
								<div>
									{{ hasEmailError("referred_email", "required") }}
								</div>
							</div>
						</div>
						<div class="form-floating mb-3">
							<!-- <input type="number" name="referred_phone" autocomplete="off" formControlName="referred_phone"
								class="form-control" id="floatingInput" placeholder="name" min="0"> -->
							<ngx-intl-tel-input
								class="form-control interphone"
								id="floatingInput"
								[cssClass]="''"
								[enableAutoCountrySelect]="true"
								[enablePlaceholder]="true"
								[searchCountryFlag]="true"
								[searchCountryField]="[
									SearchCountryField.Iso2,
									SearchCountryField.Name
								]"
								[preferredCountries]="preferredCountries"
								[selectFirstCountry]="false"
								[selectedCountryISO]="CountryISO.UnitedArabEmirates"
								[tooltipField]="TooltipLabel.Name"
								[phoneValidation]="true"
								[separateDialCode]="true"
								name="referred_phone"
								formControlName="referred_phone"
							>
							</ngx-intl-tel-input>
							<label for="floatingInput" class="mt-0">Contact Number</label>
							<div
								*ngIf="
									submitted && hasPhoneNumberError('referred_phone', 'required')
								"
								class="error"
							>
								<div>
									{{ hasPhoneNumberError("referred_phone", "required") }}
								</div>
							</div>
						</div>
						<div class="d-flex justify-content-center align-items-center mt-4">
							<!-- <div class="text-center text-sm-start me-3">
								<input type="submit" name="submit" value="Submit" class=" submit">
							</div>
							<div class="input-group1">
								<button type="cancel" class="button text-center" (click)="closeModal()">Cancel</button>
							</div> -->
							<div class="cstprng-table-cta position-relative mtrem3 started">
								<!-- <div class="position-absolute customcrl">
									<p>
										<a class="cstbtn" (click)="submitReferral()">
											<span class="text text128"> Submit</span>
											<span class="borderspan"
												> <i class="fa fa-chevron-right" aria-hidden="true"></i> 
					<lucide-icon
						name="chevron-right"
						class="lucide-arrow-icon"
					></lucide-icon>
											</span>
										</a>
									</p>
								</div> -->
								<div class="linkToPackages">
									<button
										type="button"
										(click)="submitReferral()"
										class="d-flex justify-content-start align-items-center"
									>
										<span class="text semibold text-capitalize">submit</span>
										<!-- <i class="fa fa-chevron-right" aria-hidden="true"></i> -->
										<lucide-icon
											name="chevron-right"
											class="lucide-arrow-icon"
										></lucide-icon>
										<span class="borderspan"> </span>
									</button>
								</div>

								<p class="size14 cntlink">
									Or
									<button
										(click)="closeModal()"
										class="text-decoration-underline"
									>
										cancel
									</button>
								</p>
							</div>
						</div>
					</div>
				</form>

				<!-- Success Message -->
				<!-- <div *ngIf="successMessage" class="alert alert-success mt-3" role="alert">
					{{ successMessage }}
				</div> -->

				<!-- Error Message -->
				<div *ngIf="errorMessage" class="alert alert-danger mt-3" role="alert">
					{{ errorMessage }}
				</div>

				<!-- Loading Indicator -->
				<div
					*ngIf="isLoading && !isEmailSame && !isContactSame"
					class="alert alert-info mt-3"
					role="alert"
				>
					Sending your message, please wait...
				</div>
				<!-- Error Message -->
				<div *ngIf="isContactSame" class="alert alert-danger mt-3" role="alert">
					Referrer and referred Contact Number cannot be the same
				</div>
				<!-- Error Message -->
				<div *ngIf="isEmailSame" class="alert alert-danger mt-3" role="alert">
					Referrer and referred emails cannot be the same
				</div>
			</div>
		</div>
	</div>
</div>
